<template>
  <div class="row bg-white mg-40 rounded-20 pd-lg-20">
    <div class="col-sm-3">
      <template v-if="bkDtl.rdy">
        <img
          :src="`${bkDtl.obj.defaultAttachmentUrl}?w=400&h=400&mode=crop`"
          class="cover rounded-20 wd-100p "
        />

        <ul class="list-group list-group-flush mg-b-0 tx-13">
          <li class="list-group-item pd-x-0 d-flex justify-content-between">
            <span class="tx-semibold">Харсан:</span>
            <span class="tx-rubik">{{ bkDtl.obj.viewCount }}</span>
          </li>
          <li class="list-group-item pd-x-0 d-flex justify-content-between">
            <span class="tx-semibold">Нийтлэгдсэн огноо:</span>
            <span class="tx-rubik">{{
              bkDtl.obj.createdDate | moment("YYYY/MM/DD")
            }}</span>
          </li>
          <li class="list-group-item pd-x-0 d-flex justify-content-between">
            <span class="tx-semibold">Ангилал:</span>
            <span class="tx-rubik">{{ bkDtl.obj.locTypeName }}</span>
          </li>
          <!-- <li v-if="bkDtl.obj.i2!=0" class="list-group-item pd-x-0 d-flex justify-content-between">
            <span class="tx-semibold">Үлдэгдэл:</span>
            <span class="tx-rubik">{{ bkDtl.obj.too1 }}</span>
          </li> -->
        </ul>

        <div class="text-center">
          <template v-if="bkDtl.obj.i2 == 1">
            <template v-if="orderInfo.count > 0">
            <!-- {{ orderInfo.orderInfo }} -->
              <div v-if="orderInfo.orderInfo.i1==-2" class="card rounded-10 pd-10 bd-light tx-12">
                  <div>
                    <span class="tx-semibold"
                      ><feather type="alert-circle"></feather> Таны захиалга
                      хүлээлгийн жагсаалтад бүртгэгдлээ</span
                    >
                  </div>
                  <div class="text-left text-muted">
                    <div>
                      Та уг номыг {{ orderInfo.orderInfo.i2 }} хоногийн хугацаатай унших хүсэлт илгээсэн байна. Номыг танд олгох боломжтой үед системээр мэдэгдэл хүргүүлэх болно. Баярлалаа.
                    </div>
                  </div>
              </div>
              <div v-else-if="orderInfo.orderInfo.i1==0" class="card rounded-10 pd-10 bd-light tx-12">
                <div>
                    <span class="tx-semibold" ><feather type="alert-circle"></feather> Таны захиалгыг хүлээн авлаа</span>
                  </div>

                  <div class="text-left text-muted">
                    <div>
                      Та уг номыг 
                      <!-- {{ orderInfo.orderInfo.d1 | moment("YYYY/MM/DD") }} -
                      {{ orderInfo.orderInfo.d3 | moment("YYYY/MM/DD") }} -->
                      {{orderInfo.orderInfo.i2}} хоногийн хугацаагаар унших захиалга илгээсэн байна
                    </div>
                    <div>{{ orderInfo.receiver }}</div>
                    <div>
                      <span class="tx-semibold">Байршил: </span
                      >{{ orderInfo.address }}
                    </div>
                  </div>
              </div>
              <div v-else class="card rounded-10 pd-10 bd-light tx-12">
              <!-- {{ orderInfo.orderInfo }} -->
                  <div>
                    <span class="tx-semibold"
                      ><feather type="alert-circle"></feather> Таны захиалга
                      баталгаажлаа</span
                    >
                  </div>
                  <!-- <div class="text-left text-muted">
                    <div>
                      Та {{ orderInfo.orderInfo.d1 | moment("YYYY/MM/DD") }} -
                      {{ orderInfo.orderInfo.d3 | moment("YYYY/MM/DD") }}-ны
                      хооронд уг номыг захиалсан байна.
                    </div>
                    <div>{{ orderInfo.receiver }}</div>
                    <div>
                      <span class="tx-semibold">Байршил: </span
                      >{{ orderInfo.address }}
                    </div>
                  </div> -->
                  <div class="alert alert-info mg-t-10" role="alert" v-if="orderInfo.count>0">
                    <p>Номыг буцаан өгөх хугацаа <b>{{ orderInfo.orderInfo.d3 | moment("YYYY/MM/DD") }}</b></p>
                    <hr>
                    <a v-if="orderInfo.orderInfo.i8!=999" @click="showExtendModal= true" class="btn btn-info btn-xs lh-1">Сунгах хүсэлт илгээх бол энд дарна уу</a>
                    <div v-else-if="orderInfo.orderInfo.i7==1" class="btn btn-info btn-xs lh-1">Таны 7 хоног сунгах хүсэлт амжилттай илгээгдсэн байна</div>
                  </div>
              </div>
            </template>
            <template v-else>
              <a @click="showOrder" class="btn btn-primary btn-block rounded-20"
                >
                 <!-- {{bkDtl.obj.too1>0?'Захиалах':'Хүлээлгийн жагсаалтад орох'}} -->
                Захиалах</a
              >
            </template>
          </template>
          <template v-else>
            <a @click="showOrder" class="btn btn-primary btn-block rounded-20"
              >Унших</a
            >
          </template>
        </div>
      </template>
    </div>
    <div class="col-sm">
      <div class="mg-b-20 pd-b-10 bd-b d-flex align-items-center">
        <router-link
          :to="{
            name: 'lmsLibrary',
            params: { id: 0, cid: 0, title: 'Номын сан', m: 0 },
          }"
        >
          <feather type="chevron-left" class="mg-r-10"></feather>
        </router-link>
        <h5 class="tx-semibold mg-b-0 tx-20" v-if="bkDtl.rdy">
          {{ bkDtl.obj.task }}
        </h5>

        <attach-rating
          v-if="fileInf.ready"
          :fileInf.sync="fileInf"
          class="mg-l-auto"
          disabled
          @on-rate="onRated"
          :allowHalf="false"
        />
        <button
          v-if="
            bkDtl.rdy &&
              bkDtl.obj.isRepeat &&
              bkDtl.obj.secondAttachmentUrl != ''
          "
          @click="downloadBook()"
          class="mg-l-10 btn btn-outline-success btn-xs"
        >
          <feather type="download" class="mg-r-5"></feather>
          татах
        </button>
      </div>
      <div v-html="bkDtl.obj.taskDesc" v-if="bkDtl.rdy"></div>
      <file-preview
        v-if="bkDtl.rdy"
        :id.sync="bkDtl.obj.defaultAttachmentId"
        @on-file-loaded="onFileLoaded"
        :force="true"
        :key="bkDtl.key"
        class="d-none"
      />

      <b-modal
        v-model="order.mdl"
        header-class="bd-b-0"
        content-class="rounded-20 pd-20 wd-xl-80p"
        footer-class="bd-t-0"
        centered
        size="xs"
        scrollable
      >
        <template #modal-header="{}">
          <h4 class="tx-18 tx-sm-20 mg-b-2">{{bkDtl.obj.too1>0?'Ном захиaлах':'Хүсэлт'}}</h4>
        </template>
        <div class="modal-body pd-0-f">
          <div
            v-if="order.tip != ''"
            class="alert alert-warning mg-t-20"
            role="alert"
          >
            <h6 class="alert-heading">Санамж!</h6>
            <p class="mg-b-0-f">{{ order.tip }}</p>
          </div>
          <div class="input-group">
            <div class="input-group-prepend">
              <a
                class="btn btn-outline-light bd-r-0 rounded-20"
                @click="order.month <= 14 ? 14 : order.month--"
              >
                <feather type="chevron-left"></feather>
              </a>
            </div>
            <input
              disabled
              type="text"
              class="form-control bd-r-0 bd-l-0 text-center bg-white"
              :value="`${order.month} хоног унших`"
              placeholder=""
              aria-label="Example text with button addon"
              aria-describedby="button-addon1"
            />
            <div class="input-group-append">
              <a
                class="btn btn-outline-light bd-l-0 rounded-20"
                @click="order.month >= 30 ? 30 : order.month++"
              >
                <feather type="chevron-right"></feather>
              </a>
            </div>
          </div>

          <div v-if="orderObj.list.length>=bkDtl.obj.too1" class="alert alert-warning mg-b-0 mg-t-10" role="alert">
            <!-- <p class="mb-0">Энэ номд нийт <b>{{ orderObj.count }}</b>  захиалгын хүсэлт байгаа бөгөөд та ойролцоогоор <b>{{ orderObj.totalDay }}</b> хоногийн дараа номыг биетээр авах боломжтой</p> -->
            <p>Ном үлдэгдэлгүй байгаа тул таны хүсэлт хүлээлгэд бүртгэгдэх ба номыг авах боломжтой болох үед мэдэгдэл илгээх болно.</p>
          </div>
        </div>

        <template #modal-footer>
          <div class="d-flex align-items-center wd-100p">
            <template v-if="order.task.budget > 0 && order.task.im == null">
              <button class="btn btn-primary" @click="purchaseBook()">
                <feather type="shopping-cart" class="mg-r-5" />Худалдаж авах
              </button>
            </template>
            <template v-else>
              <button
                v-if="order.loading"
                type="button"
                class="btn rounded-20 btn-light btn-block"
              >
                Түр хүлээнэ үү
              </button>
              <a
                v-else
                @click="orderBookPost"
                type="button"
                class="btn btn-primary btn-block rounded-20"
              >
                {{bkDtl.obj.too1>0?'Захиалах':'Хүлээлгийн жагсаалтад орох'}}
                <!-- Захиалах -->
              </a>
            </template>
            <!-- <button
              @click="order.mdl = false"
              v-else
              type="button"
              class="btn btn-white"
              data-dismiss="modal"
            >
              {{ $route.params.m == 2 ? "Хаах" : "Болих" }}
            </button> -->
          </div>
        </template>
      </b-modal>
    </div>

    <b-modal @ok="extendOnOk" v-model="showExtendModal" title="Хугацаа сунгах" centered cancel-title="Болих" ok-title="Илгээх">
      <div v-if="orderInfo.count>0">
        Та <b>{{ bkDtl.obj.task }}</b> номыг <b>{{ orderInfo.orderInfo.d3 | moment('YYYY.MM.DD') }}</b>-д хүлээлгэн өгөх байсныг дахин <b>7 хоногоор</b> сунгах хүсэлт илгээх гэж байна. Итгэлтэй байна уу?
      </div>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { request } from "@/api/all";
import { DatePicker, Notification } from "element-ui";
const moment = require("moment");

export default {
  components: {
    DatePicker,
    // executionList: () => ({
    //   component: import("@/components/task/components/executions/list.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000,
    // }),
    // executionReply: () => ({
    //   component: import("@/components/task/components/executions/reply.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000,
    // }),

    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    attachRating: () => ({
      component: import("@/components/modules/media/rate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      showExtendModal: false,
      orderObj:{
        list: [],
        count: null,
        totalDay: null,
      },
      scrHeight: {
        execution: 300,
        executionReply: 600,
      },
      bkDtl: {
        key: 0,
        obj: {},
        rdy: false,
      },
      fileInf: {
        ready: false,
        obj: {},
      },
      order: {
        month: 14,
        task: {},
        obj: {},
        info: "",
        coverId: null,
        attachId: null,
        tip: "",
        confirm: false,
        mdl: false,
        itemId: null,
      },
      fileDialog: {
        show: false,
        id: 0,
      },
      orderInfo: {},
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    extendOnOk(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "post", url: "Library/Add7DayRequest" },
        data:{
          id: this.orderInfo.orderInfo.id
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          request({
            api: { method: "GET", url: "library/HaveOrderForThisBook" },
            params: {
              id: this.$route.params.id,
            },
            store: this.$store,
          }).then((res) => {
            this.orderInfo = res.data;
            //console.log('sdfsd', res.data);
          });
        }
      });
    },
    onFileLoaded(e) {
      //console.log('onFileLoaded', e);
      this.fileInf = { obj: e, ready: true };
    },
    onRated(e) {
      this.fileInf.obj.myRate = e.rate;
      this.fileInf.obj.rateAvg = e.avg;
    },

    //# book execution
    executionInit(e) {
      this.$refs.executionList.initById(e);
    },

    onReachBottom() {
      // var container = this.$el.querySelector("#executions-outer");
      // $("#executions-outer").animate({
      //   scrollTop: e == "bottom" ? container.scrollHeight : 0
      // });
    },
    purchaseBook() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "post", url: "Payment/CreateInvoiceByTaskId" },
        store: this.$store,
        data: {
          id: this.order.task.id,
          taskDesc: this.order.task.task,
        },
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.$router.push(`/lms/paymentDetail/${res.data.invoiceId}`);
        }
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    orderBook() {
      // this.toggleBodyClass("addClass", "dynamic-locker");
      // let _pid = 0;
      // let proj = this.$store.state.app.groupDefaultProjects.filter(
      //   (x) => x.objectTypeId == 504
      // );
      // if(proj.length){
      //   _pid= proj[0]['id'];
      // }

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "library/OrderList" },
        params: {
          bookId: this.bkDtl.obj.id
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.orderObj= res.data;
        }
      });

      request({
        api: { method: "GET", url: "library/HaveOrderForThisBook" },
        params: {
          id: this.bkDtl.obj.id,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          if (res.data.count == 0) {
            this.toggleBodyClass("addClass", "dynamic-locker");
            let _ot = this.$store.state.app.groupDefaultProjects.filter(
              (x) => x.objectTypeId == 504
            );
            if (_ot.length) {
              request({
                api: { method: "GET", url: "Task/GetInherited" },
                params: {
                  id: 0,
                  objectTypeId: 504,
                  projectId: _ot[0].id,
                },
                store: this.$store,
              }).then((res) => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if (res != false) {
                  this.order.task = res.data.task;
                  this.order.task.organizationTaskId = this.bkDtl.obj.id;
                  this.order.task.secondUserId = this.$store.state.user.userId;
                  this.order.mdl = true;
                }
              });
            }
          } else {
            Notification.warning({
              message: "Та энэ номыг захиалах хүсэлт илгээсэн байна",
              title: "Мэдэгдэл",
              duration: 30000,
              type: "success",
              position: "top-right",
              offset: 50,
            });
          }
        }
      });
    },
    orderBookPost() {
      //console.log(this.order.task.task);
      this.order.task.task = "Ном захиалга";
      this.order.task.i2 = this.order.month;
      
      
      if(this.orderObj.list.length >= this.bkDtl.obj.too1) {
        this.order.task.i1= -2;
      }

      this.order.confirm = true;
      if (
        this.order.task.task != null &&
        this.order.task.task != "" &&
        this.order.confirm
      ) {
        this.order.loading = true;
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Task/PostInherited" },
          data: {
            model: this.order.task,
          },
          store: this.$store,
        }).then((res) => {
          this.order.loading = false;
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.order.mdl = false;
            this.init(9);
            //golomt notification deer nemelt medeelel haruulay gesen tul endees init-g 9 gesen flagtai duudav
          }
        });
      } else if (this.order.task.task == null || this.order.task.task == "") {
        Notification.warning({
          message: "Хүсэлт бичнэ үү",
          title: "Мэдэгдэл",
          duration: 30000,
          type: "success",
          position: "top-right",
          offset: 50,
        });
      } else if (!this.order.confirm) {
        Notification.warning({
          message: "Зөвшөөрөөгүй байна",
          title: "Мэдэгдэл",
          duration: 30000,
          type: "success",
          position: "top-right",
          offset: 50,
        });
      }
    },
    init(notifMode) {
      // this.bkDtl.rdy = false;
      request({
        api: { method: "GET", url: "library/HaveOrderForThisBook" },
        params: {
          id: this.$route.params.id,
        },
        store: this.$store,
      }).then((res) => {
        this.orderInfo = res.data;
        if(notifMode==9){
          //  <div class="text-left text-muted">
          //           <div>
          //             Та уг номыг  
          //             {{orderInfo.orderInfo.i2}} хоногийн хугацаагаар унших захиалга илгээсэн байна
          //           </div>
          //           <div>{{ orderInfo.receiver }}</div>
          //           <div>
          //             <span class="tx-semibold">Байршил: </span
          //             >{{ orderInfo.address }}
          //           </div>
          //         </div>
          Notification.success({
              message: `Захиалга амжилттай илгээгдлээ. ${this.orderInfo.receiver} ${this.orderInfo.address}`,
              title: "Амжилттай",
              duration: 30000,
              type: "success",
              position: "top-right",
              offset: 50,
            });

        }
        //console.log('sdfsd', res.data);
      });
      request({
        api: { method: "GET", url: "Task/taskInheritedDetail" },
        params: {
          id: this.$route.params.id,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          //console.log(res);
          this.order.info = res.data.task.taskDesc;
          this.order.attachId = res.data.task.secondAttachmentId;
          this.order.task = res.data.task;
          this.bkDtl.obj = res.data.task;
          this.bkDtl.key = res.data.id;
          this.bkDtl.rdy = true;
          if(this.order.attachId>0){
            this.showOrder();
          }
          //this.order.mdl = true;
        }
      });
    },
    showOrder() {
      console.log('this.bkDtl.obj.i2', this.bkDtl.obj.i2);
      if (this.bkDtl.obj.i2 == 0) {
        this.$router.push({
          name: "lmsLibrary",
          params: {
            id: this.bkDtl.obj.id,
            cid: 0,
            title: this.bkDtl.obj.task,
            m: 6,
          },
        });
      } else {
        //this.order.mdl = true;
        this.orderBook();
      }
      // if (this.bkDtl.obj.secondAttachmentId != null) {
      //   this.$router.push({
      //     name: "lmsLibrary",
      //     params: {
      //       id: this.bkDtl.obj.id,
      //       cid: 0,
      //       title: this.bkDtl.obj.task,
      //       m: 6,
      //     },
      //   });
      // } else {
      //   //this.order.mdl = true;
      //   this.orderBook();
      // }
    },
    downloadBook() {
      window.open(
        this.bkDtl.obj.secondAttachmentUrl +
          "?i=" +
          Math.floor(Math.random() * 100),
        "_blank"
      );
    },
    bookDetail(id) {
      this.bkDtl.rdy = false;
      request({
        api: { method: "GET", url: "Task/taskInheritedDetail" },
        params: {
          id: id,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.bkDtl.obj = res.data.task;
          this.bkDtl.rdy = true;
          //console.log(res.data.task);
        }
      });
    },
    showFile(id) {
      //console.log('showFile=> ', id);
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    acceptOrderPost() {
      request({
        data: {
          id: this.order.task.id,
        },
        api: { url: "library/AcceptOrder", method: "POST" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.order.mdl = false;
          this.init();
          this.initLibrarianDashboard();
          Notification.info({
            message: res.msg,
            duration: 30000,
            type: "info",
            position: "top-right",
            offset: 50,
          });
        }
      });
    },
  },
};
</script>
